// extracted by mini-css-extract-plugin
module.exports = {"bannerItem":"PageBanner_bannerItem__2rA8I"};